import { useQuery } from '@tanstack/react-query';
import { configClient } from '../lib/supabase/configClient';
import { translationsClient } from '../lib/translations';
import { navigationClient } from '../lib/navigation';
import type { SupportedLanguages } from '../i18n';

// Clés de requête pour React Query
const queryKeys = {
  config: ['config'] as const,
  translations: (language: SupportedLanguages) => ['translations', language] as const,
  navigation: ['navigation'] as const
};

export const useAirtableQuery = {
  useConfig() {
    return useQuery({
      queryKey: queryKeys.config,
      queryFn: () => configClient.getConfig(),
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
    });
  },

  useTranslations(language: SupportedLanguages) {
    return useQuery({
      queryKey: queryKeys.translations(language),
      queryFn: async () => {
        const [generalTranslations, categoryTranslations] = await Promise.all([
          translationsClient.getGeneralTranslations(),
          translationsClient.getCategoryTypeTranslations()
        ]);

        return {
          ...generalTranslations,
          ...categoryTranslations
        };
      },
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
    });
  },

  useNavigation() {
    return useQuery({
      queryKey: queryKeys.navigation,
      queryFn: () => navigationClient.getNavigation(),
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
    });
  }
};